import { Utilities } from 'web-core';

export const STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'completed', label: 'Completed' },
  { value: 'disconnected', label: 'Disconnected' },
  { value: 'connected', label: 'In progress' },
  { value: 'created', label: 'Created' },
];

export const statusLabel = (status) =>
  STATUS_OPTIONS.find((option) => option.value === status)?.label || status;

export const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined) {
    return '-';
  }
  const minutes = Math.floor(seconds / 60);
  const remainder = String(seconds % 60).padStart(2, '0');
  return `${minutes}:${remainder}`;
};

export const formatDateTime = (value) =>
  value ? Utilities.formattedLocalDateTime(value) : '-';

export const formatPercent = (rate) =>
  rate === null || rate === undefined ? '-' : `${Math.round(rate * 100)}%`;
